import details from '@/store/base.details';
import { ExportBatch } from '@/types';
import { AsyncModule } from 'vuex-async-mutations';

export default {
  namespaced: true,

  async: true,

  modules: {
    details: details<ExportBatch>('/batches'),
  },

  actionsAsync: {
    ['batch:delete']: {
      handler(context, { batchId }: { batchId: string }) {
        return this.$axios.delete(`batches/${batchId}`);
      },
    },
  },
} as AsyncModule<any, any>;
